import React, {useCallback, useEffect, useMemo, useState} from 'react'
import { ICar } from '../../../models/Car'
import {maxZoomLevel, defaultMapZoomLevel} from '../../config/constants'
import {getFullAddress} from '../../helpers/carLocation'
import {usePrev} from '../hocs/hooks'
import CarPanel from '../user/cars/CarPanel'
import MapsInfoWindow from './MapsInfoWindow'
import CarMapsOverlay from './CarMapsOverlay'
import {IMaps} from './mapsUtil'

const MapsCars = (
  { maps, cars, onChange, initialSelected, firstSelection, area, prefecture, zoom = defaultMapZoomLevel}: {
    maps: IMaps
    onChange?: (car: ICar) => any
    cars: ReadonlyArray<ICar>
    initialSelected?: ICar
    firstSelection: boolean,
    car?: string
    area?: string
    prefecture?: string
    zoom: number
  }
) => {
  const [selected, setSelected] = useState(initialSelected)
  const openView = useCallback((car: ICar) => {
    setSelected(car)
    onChange?.(car)
  }, [onChange])
  const openViews = useMemo(() => Object.fromEntries(
    cars.map(car => [car._id, () => openView(car)])
  ), [cars, openView])
  const prevInitialSelected = usePrev(initialSelected)
  useEffect(() => void (
    initialSelected !== prevInitialSelected && initialSelected !== selected && setSelected(initialSelected)
  ), [selected, initialSelected, prevInitialSelected])
  const closeCurrent = useCallback(() => {
    if (selected) {
      setSelected(undefined)
      onChange?.(undefined)
    }
  }, [selected, onChange])
  const [lng, lat] = (selected?.locations?.length && selected.locations[0].location || [undefined, undefined])

  const addressCounts: Record<string, any> = {}
  const carsWithAddress = useMemo(() => zoom < defaultMapZoomLevel ? cars : cars.map(car => {
    const address = getFullAddress(car.locations[0])
    addressCounts[address] = addressCounts[address] === undefined ? 0 : addressCounts[address] + 1
    return { ...car, ...addressCounts[address] && { sameAddressIndex: addressCounts[address] } }
  }), [zoom])
  return <>
    {
      selected
      && <MapsInfoWindow
        lat={lat}
        lng={lng}
        maps={maps}
        onClose={closeCurrent}
      >
        <CarPanel
          firstSelection={firstSelection}
          car={selected}
          locations={selected.locations}
          showLabel={false}
          isInfoWindow
          area={area}
          prefecture={prefecture}
        />
      </MapsInfoWindow>
    }
    {(carsWithAddress || [])
      .map(
        car => {
          const {_id} = car
          const [lng, lat] = (car?.locations?.length && car?.locations[0].location || [undefined, undefined])
          return <CarMapsOverlay
            key={_id}
            maps={maps}
            price={car.price}
            lat={zoom < defaultMapZoomLevel || !(car.sameAddressIndex || 0)
              ? lat
              : lat - 0.00002 * ((maxZoomLevel + 1 - Math.min(zoom, maxZoomLevel)) ** 2) * (car.sameAddressIndex || 0)
            }
            lng={lng}
            onClick={openViews[_id]}
          />
        }
      )}
  </>
}
MapsCars.displayName = 'MapsCars'
export default MapsCars
